import { Injectable, inject } from '@angular/core';
import { catchError, Observable, OperatorFunction, throwError } from 'rxjs';
import { NotificationService } from '@gbr-monorepo/gbr-shui';

@Injectable({
    providedIn: 'root'
})
export class HttpHelperService {
    private readonly notificationService = inject(NotificationService);

    public handleError<T>(message?: string): OperatorFunction<T, T> {
        return catchError<T, Observable<never>>(error => {
            this.notificationService.show({
                title: 'Operation unsuccessful',
                description: message ?? 'There was an error while handling your request',
                type: 'error',
                duration: 3000
            });
            return throwError(() => new Error(message || (error.error.message as string)));
        });
    }
}
